<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">
    Table of Contents
  </div>
<div>
     <br/>
</div>
<div class="cfmh">
<a href="#/Text/john_9781571318169_oeb_tp_r1">Title Page</a>
</div>
<div class="cfmh">
<a href="#/Text/john_9781571318169_oeb_ded_r1">Dedication</a>
</div>
<div class="cfmh">
<a href="#/Text/john_9781571318169_oeb_epi_r1">Epigraph</a>
</div>
<div>
     <br/>
</div>
<div class="cct">
<a href="#/Text/john_9781571318169_oeb_c01_r1">I</a>
</div>
<div class="ch1">
<a href="#/Text/john_9781571318169_oeb_c01_r1#h1">1</a>
</div>
<div class="ch1">
<a href="#/Text/john_9781571318169_oeb_c01_r1#h2">2</a>
</div>
<div class="ch1">
<a href="#/Text/john_9781571318169_oeb_c01_r1#h3">3</a>
</div>
<div>
     <br/>
</div>
<div class="cct">
<a href="#/Text/john_9781571318169_oeb_c02_r1">II</a>
</div>
<div class="ch1">
<a href="#/Text/john_9781571318169_oeb_c02_r1#h1">4</a>
</div>
<div class="ch1">
<a href="#/Text/john_9781571318169_oeb_c02_r1#h2">5</a>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/john_9781571318169_oeb_c03_r1" title="Link target outside of Sample">III</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c03_r1#h1" title="Link target outside of Sample">6</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c03_r1#h2" title="Link target outside of Sample">7</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c03_r1#h3" title="Link target outside of Sample">8</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/john_9781571318169_oeb_c04_r1" title="Link target outside of Sample">IV</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c04_r1#h1" title="Link target outside of Sample">9</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c04_r1#h2" title="Link target outside of Sample">10</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c04_r1#h3" title="Link target outside of Sample">11</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c04_r1#h4" title="Link target outside of Sample">12</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c04_r1#h5" title="Link target outside of Sample">13</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/john_9781571318169_oeb_c05_r1" title="Link target outside of Sample">V</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c05_r1#h1" title="Link target outside of Sample">14</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/john_9781571318169_oeb_c06_r1" title="Link target outside of Sample">VI</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h1" title="Link target outside of Sample">15</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h2" title="Link target outside of Sample">16</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h3" title="Link target outside of Sample">17</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h4" title="Link target outside of Sample">18</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h5" title="Link target outside of Sample">19</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h6" title="Link target outside of Sample">20</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h7" title="Link target outside of Sample">21</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h8" title="Link target outside of Sample">22</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h9" title="Link target outside of Sample">23</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h10" title="Link target outside of Sample">24</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c06_r1#h11" title="Link target outside of Sample">25</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/john_9781571318169_oeb_c07_r1" title="Link target outside of Sample">VII</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c07_r1#h1" title="Link target outside of Sample">26</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c07_r1#h2" title="Link target outside of Sample">27</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c07_r1#h3" title="Link target outside of Sample">28</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c07_r1#h4" title="Link target outside of Sample">29</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c07_r1#h5" title="Link target outside of Sample">30</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c07_r1#h6" title="Link target outside of Sample">31</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c07_r1#h7" title="Link target outside of Sample">32</span>
</div>
<div>
     <br/>
</div>
<div class="cct">
<span href="#/Text/john_9781571318169_oeb_c08_r1" title="Link target outside of Sample">VIII</span>
</div>
<div class="ch1">
<span href="#/Text/john_9781571318169_oeb_c08_r1#h1" title="Link target outside of Sample">33</span>
</div>
<div>
     <br/>
</div>
<div class="cbmh">
<span href="#/Text/john_9781571318169_oeb_ata_r1" title="Link target outside of Sample">About the Author</span>
</div>
<div class="cbmh">
<span href="#/Text/john_9781571318169_oeb_bm2_r1" title="Link target outside of Sample">More Fiction from Milkweed Editions</span>
</div>
<div class="cbmh">
<span href="#/Text/john_9781571318169_oeb_bm3_r1" title="Link target outside of Sample">Milkweed Editions</span>
</div>
<div class="cbmh">
<span href="#/Text/john_9781571318169_oeb_bm4_r1" title="Link target outside of Sample">Join Us</span>
</div>
<div class="cbmh">
<span href="#/Text/john_9781571318169_oeb_bm5_r1" title="Link target outside of Sample">The Editor’s Circle of Milkweed Editions</span>
</div>
<div class="cbmh">
<span href="#/Text/john_9781571318169_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// john_9781571318169_oeb_toc_r1.vue?2082620a